import * as React from 'react';
import { Box, Container, Grid, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useConfig, useFooterHeight } from 'store/state';
export const Footer = () => {
  const [config] = useConfig();
  const [, setFooterActions] = useFooterHeight();
  const ref = React.useRef(null);
  React.useEffect(() => {
    setFooterActions.setState(ref.current.clientHeight);
  });
  return (
    <Box
      ref={ref}
      sx={{
        width: '100%',
        height: 'auto',
        backgroundColor: 'secondary.light',
        paddingTop: '1rem',
        paddingBottom: '1rem',
      }}
    >
      <Container maxWidth="lg">
        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography color="textSecondary" variant="h5" sx={{ fontWeight: 'bold' }}>
            {config.business_display_name}
          </Typography>
        </Box>
        <Grid container spacing={0}>
          <Grid size={{ xs: 12, md: 'grow' }}>
            <Typography color="textSecondary" variant="body1" align="center">
              {config.contact_phone}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 'grow' }}>
            <Typography
              noWrap
              color="textSecondary"
              variant="body1"
              align="center"
              sx={{ fontWeight: 'bold' }}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: config.contact_address.replace(', ', '<br />'),
                }}
              />
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 'grow' }}>
            <Typography color="textSecondary" variant="body1" align="center">
              {config.contact_email}
            </Typography>
          </Grid>
        </Grid>
        <Box display="flex" flexDirection="column" alignItems="center" sx={{ mt: 1 }}>
          <Typography color="textSecondary" variant="body2" align="center">
            Copyright {`${new Date().getFullYear()}`} {config.business_official_name}, All Rights
            Reserved. {config.business_display_name} is a trade name of{' '}
            {config.business_official_name}.
          </Typography>
          <Typography color="textSecondary" variant="body2" align="center">
            <Link component={RouterLink} to="/sms-terms" color="inherit">
              SMS Terms of Service
            </Link>
            {' · '}
            <Link component={RouterLink} to="/sms-privacy" color="inherit">
              SMS Privacy Policy
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
